var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.data.title))]),_vm._l((_vm.data.files),function(file,index){return _c('download-bar',{key:index,attrs:{"data":file}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }